import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { AreaChart } from '../../charts';
import { ThemeColors } from '../../../../../../helpers/ThemeColors';
const colors = ThemeColors();
const ItemVisitsChartCard = ({ labels, data }) => {
    const datasets = data.map(elem => elem.count);
    const areaChartData = {
        labels,
        datasets: [
            {
                label: 'clicks',
                data: datasets,
                borderColor: colors.themeColor1,
                pointBackgroundColor: colors.foregroundColor,
                pointBorderColor: colors.themeColor1,
                pointHoverBackgroundColor: colors.themeColor1,
                pointHoverBorderColor: colors.foregroundColor,
                pointRadius: 4,
                pointBorderWidth: 2,
                pointHoverRadius: 5,
                fill: false,
                borderWidth: 2,
                backgroundColor: colors.themeColor1_10,
            },
        ],
    };
    return (
        <Fragment>
            <Card className={`dashboard-filled-line-chart h-100`}>
                <div style={{ padding: '15px' }}>
                    <div className="float-left float-none-xs">
                        <div className="d-inline-block">
                            <h5 className="d-inline">
                                Clicks
                            </h5>
                            <span className="text-muted text-small d-block">
                                Space Booking Page Clicks
                            </span>
                        </div>
                    </div>
                </div>

                <div className="chart card-body pt-0">
                    <AreaChart shadow data={areaChartData} />
                </div>
            </Card>
        </Fragment>
    );
};

export default ItemVisitsChartCard;
